import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title (t \'Reset your password\')}}\n\n<Page::ResetPassword\n  @username={{this.username}}\n  @verificationCode={{this.verificationCode}}\n/>")